function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1_1257)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27 10H5C2.2 10 0 12.2 0 15V27C0 29.8 2.2 32 5 32H27C29.8 32 32 29.8 32 27V15C32 12.2 29.8 10 27 10Z",
  fill: "#B3B3B3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 15H7C6.4 15 6 15.4 6 16C6 16.6 6.4 17 7 17H11C11.6 17 12 16.6 12 16C12 15.4 11.6 15 11 15Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 20H7C6.4 20 6 20.4 6 21C6 21.6 6.4 22 7 22H11C11.6 22 12 21.6 12 21C12 20.4 11.6 20 11 20Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 25H7C6.4 25 6 25.4 6 26C6 26.6 6.4 27 7 27H11C11.6 27 12 26.6 12 26C12 25.4 11.6 25 11 25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 15H16C15.4 15 15 15.4 15 16C15 16.6 15.4 17 16 17H20C20.6 17 21 16.6 21 16C21 15.4 20.6 15 20 15Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 20H16C15.4 20 15 20.4 15 21C15 21.6 15.4 22 16 22H20C20.6 22 21 21.6 21 21C21 20.4 20.6 20 20 20Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 25H16C15.4 25 15 25.4 15 26C15 26.6 15.4 27 16 27H20C20.6 27 21 26.6 21 26C21 25.4 20.6 25 20 25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26 14C25.4 14 25 14.4 25 15V27C25 27.6 25.4 28 26 28C26.6 28 27 27.6 27 27V15C27 14.4 26.6 14 26 14Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35 4H0V6H35V4Z",
  fill: "#860935"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.7 4.2L32.8 0.3C32.6 0.1 32.3 0 32.1 0C31.8 0 31.6 0.1 31.3 0.3C30.9 0.7 30.9 1.4 31.3 1.8L34.4 5L31.3 8.2C30.9 8.6 30.9 9.3 31.3 9.7C31.7 10.1 32.4 10.1 32.8 9.7L36.7 5.8C37.1 5.3 37.1 4.7 36.7 4.2Z",
  fill: "#860935"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1_1257"
}, /*#__PURE__*/React.createElement("rect", {
  width: 37,
  height: 32,
  fill: "white"
})));

function SvgMattressLength({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgMattressLength as ReactComponent };